import { render, staticRenderFns } from "./AssignRoleModal.vue?vue&type=template&id=17a257d7&scoped=true&"
import script from "./AssignRoleModal.vue?vue&type=script&lang=ts&"
export * from "./AssignRoleModal.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRoleModal.vue?vue&type=style&index=0&id=17a257d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a257d7",
  null
  
)

export default component.exports